import { Role } from "@leap4/auth";

const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL + "";
export const BACKEND_SERVICE_NAME = "adte-external-conversion-backend";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.ALLOW_ALL];
export const meUrl = baseBackendRoute + "/app/me";
export const meMultiUrl = baseBackendRoute + "/app/me_multi";
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";
export const reportingBaseUrl = baseBackendRoute + "/reporting";
export const predictionBaseUrl = baseBackendRoute + "/prediction";
export const campaignsAccessUrl = baseBackendRoute + "/campaigns/accessible";
export const dashboardDailyUrl = baseBackendRoute + "/dashboard/daily";
export const dashboardComputeUrl = baseBackendRoute + "/dashboard/compute";

export const DATE_FORMAT = "YYYY-MM-DD";
